const data =
  [
    {
      'ofs': 0,
      'label': '_ Toutes les communes _'
    },
    {
      'ofs': 5621,
      'label': 'Aclens'
    },
    {
      'ofs': 5421,
      'label': 'Apples'
    },
    {
      'ofs': 5511,
      'label': 'Assens'
    },
    {
      'ofs': 5581,
      'label': 'Belmont-sur-Lausanne'
    },
    {
      'ofs': 5471,
      'label': 'Bettens'
    },
    {
      'ofs': 5513,
      'label': 'Bioley-Orjulaz'
    },
    {
      'ofs': 5514,
      'label': 'Bottens'
    },
    {
      'ofs': 5613,
      'label': 'Bourg-en-Lavaux'
    },
    {
      'ofs': 5472,
      'label': 'Bournens'
    },
    {
      'ofs': 5473,
      'label': 'Boussens'
    },
    {
      'ofs': 5622,
      'label': 'Bremblens'
    },
    {
      'ofs': 5515,
      'label': 'Bretigny-sur-Morrens'
    },
    {
      'ofs': 5624,
      'label': 'Bussigny'
    },
    {
      'ofs': 5625,
      'label': 'Bussy-Chardonney'
    },
    {
      'ofs': 5882,
      'label': 'Chardonne'
    },
    {
      'ofs': 5475,
      'label': 'Chavannes-le-Veyron'
    },
    {
      'ofs': 5627,
      'label': 'Chavannes-près-Renens'
    },
    {
      'ofs': 5582,
      'label': 'Cheseaux-sur-Lausanne'
    },
    {
      'ofs': 5476,
      'label': 'Chevilly'
    },
    {
      'ofs': 5601,
      'label': 'Chexbres'
    },
    {
      'ofs': 5628,
      'label': 'Chigny'
    },
    {
      'ofs': 5629,
      'label': 'Clarmont'
    },
    {
      'ofs': 5785,
      'label': 'Corcelles-le-Jorat'
    },
    {
      'ofs': 5883,
      'label': 'Corseaux'
    },
    {
      'ofs': 5884,
      'label': 'Corsier-sur-Vevey'
    },
    {
      'ofs': 5477,
      'label': 'Cossonay'
    },
    {
      'ofs': 5478,
      'label': 'Cottens (Vaud)'
    },
    {
      'ofs': 5583,
      'label': 'Crissier'
    },
    {
      'ofs': 5479,
      'label': 'Cuarnens'
    },
    {
      'ofs': 5516,
      'label': 'Cugy (Vaud)'
    },
    {
      'ofs': 5480,
      'label': 'Daillens'
    },
    {
      'ofs': 5631,
      'label': 'Denens'
    },
    {
      'ofs': 5632,
      'label': 'Denges'
    },
    {
      'ofs': 5481,
      'label': 'Dizy'
    },
    {
      'ofs': 5518,
      'label': 'Echallens'
    },
    {
      'ofs': 5633,
      'label': 'Echandens'
    },
    {
      'ofs': 5634,
      'label': 'Echichens'
    },
    {
      'ofs': 5635,
      'label': 'Ecublens (Vaud)'
    },
    {
      'ofs': 5584,
      'label': 'Epalinges'
    },
    {
      'ofs': 5788,
      'label': 'Essertes'
    },
    {
      'ofs': 5521,
      'label': 'Etagnières'
    },
    {
      'ofs': 5604,
      'label': 'Forel (Lavaux)'
    },
    {
      'ofs': 5523,
      'label': 'Froideville'
    },
    {
      'ofs': 5484,
      'label': 'Gollion'
    },
    {
      'ofs': 5485,
      'label': 'Grancy'
    },
    {
      'ofs': 5673,
      'label': 'Hermenches'
    },
    {
      'ofs': 5885,
      'label': 'Jongny'
    },
    {
      'ofs': 5804,
      'label': 'Jorat-Menthue'
    },
    {
      'ofs': 5806,
      'label': 'Jorat-Mézières'
    },
    {
      'ofs': 5585,
      'label': 'Jouxtens-Mézery'
    },
    {
      'ofs': 5474,
      'label': 'La Chaux (Cossonay)'
    },
    {
      'ofs': 5498,
      'label': 'La Sarraz'
    },
    {
      'ofs': 5586,
      'label': 'Lausanne'
    },
    {
      'ofs': 5587,
      'label': 'Le Mont-sur-Lausanne'
    },
    {
      'ofs': 5638,
      'label': 'Lonay'
    },
    {
      'ofs': 5639,
      'label': 'Lully (Vaud)'
    },
    {
      'ofs': 5487,
      'label': 'Lussery-Villars'
    },
    {
      'ofs': 5640,
      'label': 'Lussy-sur-Morges'
    },
    {
      'ofs': 5606,
      'label': 'Lutry'
    },
    {
      'ofs': 5790,
      'label': 'Maracon'
    },
    {
      'ofs': 5489,
      'label': 'Mex (Vaud)'
    },
    {
      'ofs': 5490,
      'label': 'Moiry'
    },
    {
      'ofs': 5540,
      'label': 'Montilliez'
    },
    {
      'ofs': 5792,
      'label': 'Montpreveyres'
    },
    {
      'ofs': 5642,
      'label': 'Morges'
    },
    {
      'ofs': 5527,
      'label': 'Morrens (Vaud)'
    },
    {
      'ofs': 5805,
      'label': 'Oron'
    },
    {
      'ofs': 5529,
      'label': 'Oulens-sous-Echallens'
    },
    {
      'ofs': 5494,
      'label': 'Pampigny'
    },
    {
      'ofs': 5588,
      'label': 'Paudex'
    },
    {
      'ofs': 5495,
      'label': 'Penthalaz'
    },
    {
      'ofs': 5496,
      'label': 'Penthaz'
    },
    {
      'ofs': 5533,
      'label': 'Poliez-Pittet'
    },
    {
      'ofs': 5589,
      'label': 'Prilly'
    },
    {
      'ofs': 5643,
      'label': 'Préverenges'
    },
    {
      'ofs': 5607,
      'label': 'Puidoux'
    },
    {
      'ofs': 5590,
      'label': 'Pully'
    },
    {
      'ofs': 5591,
      'label': 'Renens (Vaud)'
    },
    {
      'ofs': 5644,
      'label': 'Reverolle'
    },
    {
      'ofs': 5609,
      'label': 'Rivaz'
    },
    {
      'ofs': 5592,
      'label': 'Romanel-sur-Lausanne'
    },
    {
      'ofs': 5645,
      'label': 'Romanel-sur-Morges'
    },
    {
      'ofs': 5798,
      'label': 'Ropraz'
    },
    {
      'ofs': 5535,
      'label': 'Saint-Barthélemy (Vaud)'
    },
    {
      'ofs': 5888,
      'label': 'Saint-Légier-La Chiésaz'
    },
    {
      'ofs': 5646,
      'label': 'Saint-Prex'
    },
    {
      'ofs': 5610,
      'label': 'Saint-Saphorin (Lavaux)'
    },
    {
      'ofs': 5648,
      'label': 'Saint-Sulpice (Vaud)'
    },
    {
      'ofs': 5611,
      'label': 'Savigny'
    },
    {
      'ofs': 5499,
      'label': 'Senarclens'
    },
    {
      'ofs': 5799,
      'label': 'Servion'
    },
    {
      'ofs': 5501,
      'label': 'Sullens'
    },
    {
      'ofs': 5688,
      'label': 'Syens'
    },
    {
      'ofs': 5500,
      'label': 'Sévery'
    },
    {
      'ofs': 5649,
      'label': 'Tolochenaz'
    },
    {
      'ofs': 5650,
      'label': 'Vaux-sur-Morges'
    },
    {
      'ofs': 5890,
      'label': 'Vevey'
    },
    {
      'ofs': 5651,
      'label': 'Villars-Sainte-Croix'
    },
    {
      'ofs': 5692,
      'label': 'Vucherens'
    },
    {
      'ofs': 5503,
      'label': 'Vufflens-la-Ville'
    },
    {
      'ofs': 5653,
      'label': 'Vufflens-le-Château'
    },
    {
      'ofs': 5803,
      'label': 'Vulliens'
    },
    {
      'ofs': 5654,
      'label': 'Vullierens'
    }
  ]
export default data



// WEBPACK FOOTER //
// ./src/components/cgil-vue-olmap/communesBBLidar2012.js